export default __webpack_public_path__ + "static/media/Group 42.066bb778.svg";